import * as md5 from 'md5'

export const openFile = (url: any): void => {
	const link = document.createElement('a')
	link.href = url
	link.setAttribute('target', '_blank')
	document.body.appendChild(link)
	link.click()
	link.parentNode.removeChild(link)
}

export const downloadFile = (url: any, title: string): void => {
	const link = document.createElement('a')
	link.href = url
	link.setAttribute('download', title)
	document.body.appendChild(link)
	link.click()
	link.parentNode.removeChild(link)
}

export const readFile = async (file: Blob, isBase64?: boolean): Promise<any> => {
	return new Promise((resolve): void => {
		const FReader = new FileReader()
		if (isBase64) {
			FReader.readAsText(file)
		} else {
			FReader.readAsDataURL(file)
		}
		FReader.onload = (oFREvent): void => resolve(oFREvent.target.result)
	})
}

export const getBase64File = (dataString: string): string => {
	const header = ';base64,'
	return dataString.substr(dataString.indexOf(header) + header.length)
}

export const changeFileName = (file: { name: string }): string => {
	const date = new Date()
	const fileName = file.name.split('.')
	const ext = fileName.pop()
	const name = md5(file.name + date)
	return `${name}.${ext}`.toLowerCase()
}

export const getIconNameFromFileName = (filename: string): string => {
	const arr = filename.split('.')
	const ext = arr.pop().toLowerCase()
	let iconName = ''
	switch (ext) {
		case 'pdf':
			iconName = 'file-pdf'
			break
		case 'mp3':
			iconName = 'play-circle'
			break
		case 'ppt':
		case 'pptx':
			iconName = 'file-ppt'
			break
		case 'xls':
		case 'xlsx':
			iconName = 'file-excel'
			break
		case 'doc':
		case 'docx':
			iconName = 'file-word'
			break
		case 'png':
		case 'jpg':
		case 'jpeg':
			iconName = 'file-image'
			break
		default:
			iconName = 'file-unknown'
	}
	return iconName
}

export const canShowFile = (fileName: string, isMobile?: boolean): boolean => {
	const arr = fileName.split('.')
	const ext = arr.pop().toLowerCase()
	switch (ext) {
		case 'jpg':
		case 'jpeg':
		case 'png':
			return true
		case 'pdf':
			return !isMobile
		default:
			return false
	}
}

export const isImageFile = (fileName: string): boolean => {
	if (!fileName) {
		return null
	}
	const arr = fileName.split('.')
	const ext = arr.pop().toLowerCase()
	switch (ext) {
		case 'jpg':
		case 'jpeg':
		case 'png':
			return true
		default:
			return false
	}
}

export const getVideoResolution = (file: File): Promise<{ width: number; height: number }> =>
	new Promise((res, rej): void => {
		const reader = new FileReader()
		reader.addEventListener('load', (e): void => {
			const blob = new Blob([e.target.result], { type: file.type })
			const url = (window.URL || window.webkitURL).createObjectURL(blob)
			const video = document.createElement('video')
			video.preload = 'metadata'
			video.addEventListener('loadedmetadata', (): void => {
				const { videoWidth, videoHeight } = video
				if (videoWidth && videoHeight) {
					return res({ width: videoWidth, height: videoHeight })
				}
				return rej()
			})
			video.src = url
		})
		reader.readAsArrayBuffer(file)
	})
